"use client";

import { useState } from "react";
import { ChevronDown } from "lucide-react";

import { cn } from "@/lib/utils";

interface FaqItem {
	question: string;
	answer: string;
}

interface PdpFaqInlineProps {
	faq: FaqItem[];
	/** Language of the FAQ text when it differs from the page (es text on an es-mx page). */
	lang?: string;
}

export function PdpFaqInline({ faq, lang }: PdpFaqInlineProps) {
	const [openIdx, setOpenIdx] = useState<number | null>(0);

	return (
		<div lang={lang}>
			{faq.map((item, idx) => {
				const open = openIdx === idx;
				return (
					<div key={item.question} className="border-t border-border py-4">
						<button
							type="button"
							onClick={() => setOpenIdx(open ? null : idx)}
							className="flex w-full items-center justify-between gap-3 text-left"
							aria-expanded={open}
						>
							<h4 className="text-base font-semibold text-foreground">{item.question}</h4>
							<ChevronDown
								className={cn(
									"h-4 w-4 shrink-0 text-muted-foreground transition-transform [transition-duration:var(--duration-fast)] [transition-timing-function:var(--ease-smooth-out)] motion-reduce:transition-none",
									open && "rotate-180",
								)}
								strokeWidth={2}
								aria-hidden
							/>
						</button>
						<div
							inert={!open}
							aria-hidden={!open}
							className={cn(
								"grid overflow-hidden transition-[grid-template-rows] [transition-duration:var(--duration-fast)] [transition-timing-function:var(--ease-smooth-out)] motion-reduce:transition-none",
								open ? "grid-rows-[1fr]" : "grid-rows-[0fr]",
							)}
						>
							<div className="overflow-hidden">
								<p className="text-foreground/85 pt-2.5 text-sm leading-relaxed">{item.answer}</p>
							</div>
						</div>
					</div>
				);
			})}
		</div>
	);
}
